import React from "react"
import {
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
    ScatterChart,
    Scatter,
    ZAxis,
    Cell
} from "recharts"
import styles from "../charts.module.css"
import { formatValueWithUnit } from "../chartUtils"

const ChartHeatmap = ({ data, unit = "" }) => {
    const allDataZero = data.every(item => item.value === 0)
    const dayLabels = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"]

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const item = payload[0].payload
            return (
                <div className={styles.tooltip}>
                    <p>
                        <span className={styles.tooltipLabel}>{item.day} - {item.hourLabel}h</span>
                        <span className={styles.tooltipValue}>{formatValueWithUnit(item.value, unit)}</span>
                    </p>
                </div>
            )
        }
        return null
    }

    // Determinar intensidade da cor
    const maxValue = Math.max(...data.map(d => d.value))
    const getColor = (value) => {
        if (maxValue === 0) return "var(--surface-hover)"
        const intensity = value / maxValue
        return `rgba(123, 97, 255, ${0.15 + intensity * 0.85})` // roxo padrão Oktto
    }

    const renderCell = (props) => {
        const { cx, cy, payload } = props
        const size = 14
        return (
            <rect
                x={cx - size / 2}
                y={cy - size / 2}
                width={size}
                height={size}
                rx={3}
                fill={getColor(payload.value)}
                stroke="var(--surface-card)"
                strokeWidth={1}
            />
        )
    }

    return allDataZero ? (
        <div className={styles.emptyChartMessage}>
            <p>Nenhum dado para exibir</p>
        </div>
    ) : (
        <ResponsiveContainer width="100%" height="100%">
            <ScatterChart margin={{ top: 14, right: 16, bottom: 12, left: 4 }}>
                <XAxis
                    dataKey="hour"
                    type="number"
                    domain={[0, 23]}
                    tickCount={24}
                    tickFormatter={(h) => `${String(h).padStart(2, '0')}h`}
                    interval={2}
                    axisLine={false}
                    tickLine={false}
                    tick={{ fill: "var(--text-secondary)", fontSize: 12, fontWeight: 600 }}
                />
                <YAxis
                    dataKey="dayIndex"
                    type="number"
                    domain={[0, 6]}
                    tickCount={7}
                    tickFormatter={(dayIndex) => dayLabels[dayIndex]}
                    name="Dia"
                    reversed={true}
                    axisLine={false}
                    tickLine={false}
                    tick={{ fill: "var(--text-secondary)", fontSize: 12, fontWeight: 600 }}
                />
                <ZAxis dataKey="value" />
                <Tooltip content={<CustomTooltip />} offset={12} wrapperStyle={{ outline: "none" }} />

                <Scatter data={data} shape={renderCell}>
                    {data.map((entry, index) => (
                        <Cell
                            key={`cell-${index}`}
                            fill={getColor(entry.value)}
                        />
                    ))}
                </Scatter>
            </ScatterChart>
        </ResponsiveContainer>
    )
}

export default ChartHeatmap
